import { useSelector } from "react-redux";


import classes from './ChangePage.module.css'
import { Link } from "react-router-dom";
import PageTitle from "../../fragments/PageTitle";
import LoadingSpinner from "../../common/LoadingSpinner";
import WorkQToolTips from "./WorkQToolTips";

export default function ChangePageTitle({openListHandler, isListOpened}) {
    const selectedWorkQueue = useSelector((state) => state.workqueue.selectedWorkQueue);

    // Only show the title-side loader on the initial load (no data yet).
    // Once the workQ has rows, background refreshes should not flash this loader.
    const loading = useSelector((state) => {
        const listLen = state.filter.currentpagedata?.data?.length || 0;
        return state.filter.loading && listLen === 0;
    })

    return <PageTitle>
        {selectedWorkQueue && <div className={`${classes.title_button_container} `}>
            <Link to={`/work-queues/${selectedWorkQueue.slug}`}>{selectedWorkQueue.name}</Link>
            <button onClick={openListHandler} className={`${classes.title_button} ${isListOpened ? classes.button_disabled : ''}`}>                
                <span className={classes.list_status_indicator}><i className="ti ti-chevron-down"></i></span>
            </button>   

            {selectedWorkQueue.description && <WorkQToolTips description={selectedWorkQueue.description} />}

            {loading && <div className={classes.loading_container}> 
                <LoadingSpinner white={true}/>
                <span className={classes.loading_text}>Loading...</span>    
            </div> }
        </div>}
    </PageTitle>
}